import React from 'react';
import './DateFilterBar.css';

// Date range picker shared by the support-admin and organizer analytics
// dashboards: preset buttons (Today / 7 Days / 30 Days / This Month) plus
// a custom "from -> to" range.
const DateFilterBar = ({ datePreset, from, to, today, onPresetChange, onFromChange, onToChange }) => {
    return (
        <div className='analyticsDateArea'>
            <div className='analyticsDateFilters'>
                <button
                    type='button'
                    className={datePreset === 'today' ? 'active' : ''}
                    onClick={() => onPresetChange('today')}
                >
                    Today
                </button>

                <button
                    type='button'
                    className={datePreset === '7days' ? 'active' : ''}
                    onClick={() => onPresetChange('7days')}
                >
                    7 Days
                </button>

                <button
                    type='button'
                    className={datePreset === '30days' ? 'active' : ''}
                    onClick={() => onPresetChange('30days')}
                >
                    30 Days
                </button>

                <button
                    type='button'
                    className={datePreset === 'month' ? 'active' : ''}
                    onClick={() => onPresetChange('month')}
                >
                    This Month
                </button>

                <button
                    type='button'
                    className={datePreset === 'custom' ? 'active' : ''}
                    onClick={() => onPresetChange('custom')}
                >
                    Custom
                </button>
            </div>

            {/* ------------------------------------------------ */}
            {/* Custom Date Inputs */}
            {/* ------------------------------------------------ */}

            {datePreset === 'custom' && (
                <div className='analyticsCustomDates'>
                    <div className='analyticsDateField'>
                        <label>From</label>

                        <input type='date' value={from} max={to} onChange={onFromChange} />
                    </div>

                    <div className='analyticsDateField'>
                        <label>To</label>

                        <input type='date' value={to} min={from} max={today} onChange={onToChange} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateFilterBar;
